'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Roghnaigh am'
};

exports['default'] = locale;